import { Button } from '../button';

const RealizeTableRowActionButton = window.TableRowActionButton;

export default class TableRowActionButton extends RealizeTableRowActionButton {
	static defaultProps = {
		...RealizeTableRowActionButton.defaultProps,
		buttonComponent: Button,
	};

	constructor(props) {
		super(props);
		this.renderButton = TableRowActionButton.prototype.renderButton.bind(this);
	}

	renderButton() {
		const { conditionToShowActionButton, data } = this.props;

		return conditionToShowActionButton(data)
		? this.renderButtonComponent()
		: [];
	}

	renderButtonComponent() {
		const { buttonComponent: Component } = this.props;

		return <Component
		{...this.props}
		method={this.actionButtonMethod()}
		href={this.actionButtonHref()}
		onClick={this.actionButtonClick}
		key="a"
		/>;
	}
}
